import Circlebtn from "./Circlebtn";
import { AlertBoxProps } from "../common/types";
import { styled, useTheme as styledTheme } from "styled-components";

const AlertTranspContainer = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 9999;
`;

const AlertMiniBox = styled.div<{ $showButton?: boolean }>`
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  padding: 15px;
  width: 300px;
  background-color: ${({ theme }) => theme.body};
  height: auto;
  // max-height: 80vh;
  border-radius: 10px;
  @media (max-width: 576px) {
    width: 75%;
  }

  .alertContent {
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-direction: column;

    min-height: ${({ $showButton }) => ($showButton ? "350px" : "auto")};
    padding-bottom: ${({ $showButton }) => ($showButton ? "2rem" : "0")};
    border-radius: 5px;
    text-align: center;
    @media (max-width: 576px) {
      min-height: ${({ $showButton }) => ($showButton ? "200px" : "auto")};
    }

    .message {
      font-weight: 200;
      max-height: 200px;
      overflow-y: auto;
      padding: 10px 0;
    }

    .twoBtnsContainer {
      width: 100%;
      display: flex;
      justify-content: space-around;

      button {
        border: none;
        border-radius: 4px;
        width: 60px;
        padding: 4px 2px;
        font-size: 13px;
        font-weight: 400;
        background-color: #d1d1d1;

        &:hover {
          background-color: #bbb;
        }
        &:focus {
          background-color: #aaa;
        }
      }
    }
  }
`;
function AlertBox({
  alertTitle,
  message,
  onClose,
  isError,
  isTwoButtons,
  onOk,
  onYes,
  showButton = true,
}: AlertBoxProps) {
  const defaultStyledTheme = styledTheme();
  return (
    <>
      {/* menuCrlBtn is added to prevent closing the menu on click during log out */}
      <AlertTranspContainer className="menuCrlBtn">
        <AlertMiniBox $showButton={showButton} className="menuCrlBtn">
          <div className="alertContent menuCrlBtn">
            <strong
              className="menuCrlBtn"
              style={{
                margin: "10px 0",
                color: isError ? "red" : defaultStyledTheme.text,
              }}
            >
              {" "}
              {alertTitle}
            </strong>
            <p className="message menuCrlBtn">{message}</p>

            {showButton &&
              (isTwoButtons ? (
                <div className="twoBtnsContainer">
                  <button className="menuCrlBtn" onClick={onClose}>
                    No
                  </button>
                  {onYes && (
                    <button
                      className="menuCrlBtn"
                      onClick={() => {
                        onYes();
                        onClose();
                      }}
                    >
                      Yes
                    </button>
                  )}
                </div>
              ) : (
                <div>
                  <Circlebtn
                  onClick={() => {      
                    if(onOk){
                      // console.log("Trying to execute onOk");
                      onOk(); // Call onOk function
                    }
                    onClose();
                  }}

                  $size="50px"
                  $maxTranslation={50}
                >
                  <div
                    className="txtPresent"
                    style={{ fontWeight: 200, fontSize: "12px" }}
                  >
                    OK
                  </div>
                </Circlebtn>
                </div>
              ))}
          </div>
        </AlertMiniBox>
      </AlertTranspContainer>
    </>
  );
}

export default AlertBox;
